import styled from 'styled-components';

export const TextAreaContainer = styled.div`
  margin-top: 20px;
  padding: 15px;
  border-top: 1px solid #ddd;
  background-color: #f9f9f9;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.05);
`;

export const TextAreaHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

export const TextAreaTitle = styled.h3`
  font-size: 14px;
  color: #555;
  margin: 0;
  font-weight: 500;
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 80px;
  padding: 10px;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: none;
  margin-bottom: 10px;
  transition: border-color 0.3s, box-shadow 0.3s;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  }
`;

export const ControlsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SubmitButton = styled.button`
  padding: 10px 20px;
  font-size: 0.9em;
  color: white;
  background-color: #28a745;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #218838;
  }

  &:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
  }
`;

export const FeedbackMessage = styled.div`
  margin-top: 10px;
  padding: 8px;
  border-radius: 4px;
  font-size: 0.9em;
  color: #0c5460;
  background-color: #d1ecf1;
  border: 1px solid #bee5eb;
  display: ${(props) => (props.visible ? 'block' : 'none')};
`;
